import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { Office } from '@/types/office';

export const getChildOfficesByLineID = async (
  line_id: string,
  accessToken: string,
  child_id: number
): Promise<ApiResult<Office[]>> => {
  const { status, result } = await callApiWithoutToken<Office[]>(
    `line/${line_id}/children/${child_id}/offices`,
    'GET',
    accessToken,
    undefined
  );
  return { status, result };
};
